import { DialogHandler } from '../../components/dialog/DialogHandler';
import { AbstractBlock } from '../AbstractBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';

export class GPSSelectButton extends AbstractBlock {
  constructor(title: string) {
    super('gps-select-button', '');
    this.title = title;
    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_gps_select_button', () => {
        DialogHandler.showGpsDialog();
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml(): HTMLElement {
    const el = document.createElement('button');
    el.setAttribute('text', this.title);
    el.setAttribute('callbackKey', 'click_gps_select_button');
    el.setAttribute('web-class', 'file_up_button');
    return el;
  }
}
